module.exports = __webpack_public_path__ + "img/triangle-right.b00f78b4.svg";